import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=f6ab201a&scoped=true&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=f6ab201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ab201a",
  null
  
)

export default component.exports